export default __webpack_public_path__ + "static/media/17631.55e5fdb4.jpg";